const layout2Settings = {
  header: { show: true },
  searchBox: { open: false },
  secondarySidebar: { show: false },
  leftSidebar: {
    open: true,
    secondaryNavOpen: false,
    theme: "sidebar-dark-purple"
  }
};

export default layout2Settings;
